import { Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import { Random } from '../../../Utility/Random';
import { delay } from '../../../Utility/Task/TaskQueue';

export class ScissorsIdle extends AnimationClip {
    public *execute(gameObject: GameObject): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        const loopDuration = 2500;

        // Random offset.

        yield* delay(Random.value(0, 2500));

        transform.position.y = 0;

        const tween = this.getTween(transform.position);
        tween
            .easing(Easing.Quadratic.InOut)
            .to({ y: 20 }, loopDuration)
            .yoyo(true)
            .repeat(Infinity)
            .start(this.elapsedTime);

        // Loop.
        while (true) yield;
    }
}
